"use client";

import { hideModal, NiceModalContext } from "@packages/ui";
import { usePathname } from "next/navigation";
import { useContext, useEffect, useRef } from "react";

export const CloseModalsOnNavigate = () => {
  const pathname = usePathname();
  const modals = useContext(NiceModalContext);
  const modalsRef = useRef(modals);
  const isFirstRender = useRef(true);

  useEffect(() => {
    modalsRef.current = modals;
  });

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    for (const [id, state] of Object.entries(modalsRef.current)) {
      if (state?.visible) void hideModal(id);
    }
  }, [pathname]);

  return null;
};
